'use client';

import '@ui5/webcomponents-fiori/dist/WizardStep.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * A component that represents a logical step as part of the `Wizard`. It is meant to aggregate arbitrary HTML elements that form the content of a single step.
 *
 * @abstract
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/fiori-Wizard)
 */
const WizardStep = withWebComponent('ui5-wizard-step', ['icon', 'subtitleText', 'titleText'], ['branching', 'disabled', 'selected'], [], []);
WizardStep.displayName = 'WizardStep';
export { WizardStep };